// Loads the canonical province catalog once and exposes a code -> name lookup.
// The catalog is a static asset shipped with the app (same file the pipeline uses).

let cache: Map<string, string> | null = null;

export async function loadProvinceNames(): Promise<Map<string, string>> {
  if (cache) return cache;
  const map = new Map<string, string>();
  try {
    const res = await fetch("/data/provinces-catalog.json");
    const data = (await res.json()) as { provinces: Array<{ code: string; name: string }> };
    for (const p of data.provinces) map.set(p.code, p.name);
  } catch {
    // Leave empty on failure — callers fall back to showing the raw code.
  }
  cache = map;
  return map;
}
